<template>
  <div class="rapport-lans-container mb-3">
    <v-textarea
      auto-grow
      rows="1"
      outlined
      label="Rapportens namn"
      v-model="name"
      hide-details="auto"
    ></v-textarea>
    <v-expansion-panels>
      <slot name="image"></slot>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Information </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field
            outlined
            label="Författare"
            messages="Förnamn Efternamn, Förnamn Efternamn"
            v-model="author"
          ></v-text-field>
          <v-text-field
            outlined
            label="Utgivare"
            messages="T.ex. Stockholms Marina Forskningscentrum"
            v-model="publisher"
          ></v-text-field>
          <div class="flex mt-5">
            <v-text-field outlined label="Publiceringsår" v-model="year"></v-text-field>
            <v-text-field outlined label="Sorteringssiffra" v-model="sortingNumber"></v-text-field>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Länkar </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-text-field
              outlined
              label="Länk till fil"
              messages="https://www...."
              placeholder="https://... "
              v-model="link"
              class="mb-2"
              :loading="!!uploadFile"
            ></v-text-field>
            <Upload @add="onAddFile" container="dokument" class="my-3 mb-5">
              <div class="upload-container">
                <v-progress-circular
                  v-if="uploadFile"
                  :rotate="360"
                  :size="40"
                  :width="3"
                  :value="uploadFile.progress"
                  color="primary"
                >
                  <span class="caption">{{ `${uploadFile.progress}%` }}</span>
                </v-progress-circular>
                <template v-else>
                  <v-icon large color="#ececec">mdi-cloud-upload-outline</v-icon>
                  <h5>Klicka eller dra fil hit för att lägga till rapport</h5>
                </template>
              </div>
            </Upload>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Nyckelord </v-expansion-panel-header>
        <v-expansion-panel-content> <slot name="keywords"></slot> </v-expansion-panel-content
      ></v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Upload from '@/components/shared/Upload.vue'

export default {
  name: 'ReportLansstyrelse',
  props: {
    article_name: { type: String },
    article_sort: { type: String },
    article_year: { type: String },
    article_file: { type: String },
    article_author: { type: String },
    article_department: { type: String },
  },
  components: {
    Upload,
  },
  data() {
    return {
      uploadFile: null,
    }
  },
  computed: {
    publisher: {
      get() {
        return this.article_department
      },
      set(val) {
        this.$emit('update', { article_department: val })
      },
    },
    author: {
      get() {
        return this.article_author
      },
      set(val) {
        this.$emit('update', { article_author: val })
      },
    },

    sortingNumber: {
      get() {
        return this.article_sort
      },
      set(val) {
        this.$emit('update', { article_sort: val })
      },
    },
    year: {
      get() {
        return this.article_year
      },
      set(val) {
        this.$emit('update', { article_year: val })
      },
    },
    link: {
      get() {
        return this.article_file
      },
      set(val) {
        this.$emit('update', { article_file: val })
      },
    },
    name: {
      get() {
        return this.article_name
      },
      set(val) {
        this.$emit('update', { article_name: val })
      },
    },
  },
  methods: {
    async onAddFile({ azureFile }) {
      this.uploadFile = azureFile 
      const { status, url } = await this.uploadFile.send()
      if (status === 201) {
        this.$emit('updateImmediately', { article_file: url })
      } else {
        // eslint-disable-next-line no-alert
        alert('Problem uppstod när filen skulle laddas upp')
      }
      this.uploadFile = null
    },
  },
}
</script>

<style lang="less" scoped>
.rapport-lans-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  .flex {
    display: flex;
    gap: 15px;
  }
  .upload-container {
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
